
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2un4A", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $ccHMk = parcelRequire("ccHMk");


var $6xdDU = parcelRequire("6xdDU");


var $dh538 = parcelRequire("dh538");


var $cwkWT = parcelRequire("cwkWT");


var $u9agA = parcelRequire("u9agA");

var $eyWa4 = parcelRequire("eyWa4");


var $fDXXi = parcelRequire("fDXXi");


var $iBtX5 = parcelRequire("iBtX5");

var $kdU21 = parcelRequire("kdU21");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gdv5Z = parcelRequire("gdv5Z");

var $d8SNb = parcelRequire("d8SNb");



/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");




var $1s5hv = parcelRequire("1s5hv");





var $iXCQx = parcelRequire("iXCQx");


var $31Vvl = parcelRequire("31Vvl");

const $062849b5172bd26b$var$styles = {
    container: "_2rko12b0 _1h6d8yml _12y3e4h9 _12ji1l7x _1qu2nqa1 _syazi7uo _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    avatarSkeleton: "_2rko12b0 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    firstLineSkeleton: "_2rko1rr0 _1rjc1b66",
    secondLineSkeleton: "_2rko1rr0 _1rjc1b66 _1bsbqkoa"
};
const $062849b5172bd26b$export$b7a75d9378054329 = ({ containerType: containerType })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $062849b5172bd26b$var$styles.container,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    backgroundColor: "color.background.neutral",
                    xcss: $062849b5172bd26b$var$styles.avatarSkeleton
                }),
                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    space: "space.100",
                    grow: "fill",
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            backgroundColor: "color.background.neutral",
                            xcss: $062849b5172bd26b$var$styles.firstLineSkeleton
                        }),
                        containerType ? /*#__PURE__*/ (0, $l998X.jsx)($062849b5172bd26b$var$ContainerIcon, {
                            containerType: containerType
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            backgroundColor: "color.background.neutral",
                            xcss: $062849b5172bd26b$var$styles.secondLineSkeleton
                        })
                    ]
                })
            ]
        })
    });
};
function $062849b5172bd26b$var$ContainerIcon({ containerType: containerType }) {
    const { description: description, icon: icon, containerTypeText: containerTypeText } = (0, $31Vvl.getContainerProperties)({
        containerType: containerType,
        iconSize: 'medium'
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        gap: "space.050",
        alignItems: "center",
        children: [
            icon,
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "small",
                        color: "color.text.subtle",
                        children: description
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        size: "small",
                        color: "color.text.subtle",
                        children: containerTypeText
                    })
                ]
            })
        ]
    });
}


const $c6a66ab9fd93fec3$var$styles = {
    containers: "_yv0ewxkt",
    showMoreButtonSkeleton: "_2rko1tm3 _1rjc1b66 _1bsbvbgk"
};
const $c6a66ab9fd93fec3$export$b4d5d8f3bbe29b5f = ({ numberOfContainers: numberOfContainers })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        space: "space.200",
        testId: "team-containers-skeleton",
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $d8SNb.default), {
                xcss: $c6a66ab9fd93fec3$var$styles.containers,
                gap: "space.100",
                autoFlow: "row",
                children: [
                    ...Array(numberOfContainers)
                ].map((_, index)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $062849b5172bd26b$export$b7a75d9378054329), {}, index))
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                backgroundColor: "color.background.neutral",
                xcss: $c6a66ab9fd93fec3$var$styles.showMoreButtonSkeleton
            })
        ]
    });
};



var $cHq3C = parcelRequire("cHq3C");


var $cK1S8 = parcelRequire("cK1S8");


var $3ZPUI = parcelRequire("3ZPUI");


var $g1rvx = parcelRequire("g1rvx");








var $hogmh = parcelRequire("hogmh");

const $b07c34dd4d8ba0b7$var$PRODUCT_TO_CONTAINER_TYPE = {
    Jira: 'JiraProject',
    Confluence: 'ConfluenceSpace',
    Loom: 'LoomSpace'
};
const $b07c34dd4d8ba0b7$export$f2b2f5ef0b498d26 = 2000;
const $b07c34dd4d8ba0b7$export$128b56c8c806da23 = 30000;
const $b07c34dd4d8ba0b7$export$2a2e523635b9b98e = (teamId)=>{
    const [containers, { updateContainerLoading: updateContainerLoading, updateContainerCreated: updateContainerCreated }] = (0, $3ZPUI.useCreateContainers)();
    const { refetchTeamContainers: refetchTeamContainers, teamContainers: teamContainers } = (0, $hogmh.useTeamContainers)(teamId);
    const [createdContainers, setCreatedContainers] = (0, $42omo.useState)({});
    const intervalRef = (0, $42omo.useRef)(null);
    const clearIntervalRef = ()=>{
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    };
    (0, $42omo.useEffect)(()=>{
        setCreatedContainers({});
        clearIntervalRef();
    }, [
        teamId
    ]);
    (0, $42omo.useEffect)(()=>{
        const products = Object.keys(containers);
        products.forEach((product)=>{
            const { isCreated: isCreated } = containers[product];
            if (!isCreated) return;
            const existing = createdContainers[product];
            if (existing && existing.found === false) return;
            if (existing && existing.found) return;
            const containerType = $b07c34dd4d8ba0b7$var$PRODUCT_TO_CONTAINER_TYPE[product];
            if (!containerType) return;
            const currentCount = teamContainers.filter((c)=>c.type === containerType).length;
            if (currentCount > 0) {
                setCreatedContainers((prev)=>({
                        ...prev,
                        [product]: {
                            startedAt: Date.now(),
                            found: true
                        }
                    }));
                updateContainerLoading(product, false);
                updateContainerCreated(product, false);
                return;
            }
            setCreatedContainers((prev)=>({
                    ...prev,
                    [product]: {
                        startedAt: Date.now(),
                        found: false
                    }
                }));
        });
    }, [
        containers,
        createdContainers,
        teamContainers,
        updateContainerLoading,
        updateContainerCreated
    ]);
    (0, $42omo.useEffect)(()=>{
        const hasPending = Object.values(createdContainers).some((entry)=>entry && entry.found === false);
        if (!hasPending) {
            clearIntervalRef();
            return;
        }
        if (intervalRef.current) return;
        intervalRef.current = setInterval(()=>{
            setCreatedContainers((prev)=>{
                let anyPending = false;
                const next = {
                    ...prev
                };
                Object.keys(prev).forEach((product)=>{
                    const target = prev[product];
                    if (!target || target.found) return;
                    const { startedAt: startedAt } = target;
                    const containerType = $b07c34dd4d8ba0b7$var$PRODUCT_TO_CONTAINER_TYPE[product];
                    if (!containerType) {
                        next[product] = {
                            ...target,
                            found: true
                        };
                        updateContainerLoading(product, false);
                        updateContainerCreated(product, false);
                        return;
                    }
                    const currentCount = teamContainers.filter((container)=>container.type === containerType).length;
                    const elapsed = Date.now() - startedAt;
                    if (currentCount > 0 || elapsed >= $b07c34dd4d8ba0b7$export$128b56c8c806da23) {
                        next[product] = {
                            ...target,
                            found: true
                        };
                        updateContainerLoading(product, false);
                        updateContainerCreated(product, false);
                    } else anyPending = true;
                });
                if (!anyPending) {
                    clearIntervalRef();
                    return next;
                }
                refetchTeamContainers();
                return next;
            });
        }, $b07c34dd4d8ba0b7$export$f2b2f5ef0b498d26);
        return ()=>{
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };
    }, [
        createdContainers,
        teamContainers,
        refetchTeamContainers,
        updateContainerLoading,
        updateContainerCreated
    ]);
};






var $aYWXT = parcelRequire("aYWXT");

/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $1qfLF = parcelRequire("1qfLF");


var $g5gZt = parcelRequire("g5gZt");






















parcelRequire("42omo");













function $2da7380ffeeec786$export$cd6d34d857ce4eca({ type: type }) {
    const { title: title, description: description } = $2da7380ffeeec786$var$getContainerProperties(type);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                maxLines: 1,
                weight: "medium",
                color: "color.text",
                children: title
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                gap: "space.050",
                alignItems: "center",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                    size: "small",
                    color: "color.text.subtle",
                    children: description
                })
            })
        ]
    });
}
function $2da7380ffeeec786$var$getContainerProperties(type) {
    switch(type){
        case 'ConfluenceSpace':
            return {
                description: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...$2da7380ffeeec786$var$messages.confluenceContainerDescription
                }),
                title: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...$2da7380ffeeec786$var$messages.addConfluenceContainerTitle
                })
            };
        case 'LoomSpace':
            return {
                description: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...$2da7380ffeeec786$var$messages.loomSpaceDescription
                }),
                title: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...$2da7380ffeeec786$var$messages.addLoomContainerTitle
                })
            };
        case 'JiraProject':
            return {
                description: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...$2da7380ffeeec786$var$messages.jiraProjectDescription
                }),
                title: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...$2da7380ffeeec786$var$messages.addJiraProjectTitle
                })
            };
        case 'WebLink':
            return {
                description: null,
                title: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...$2da7380ffeeec786$var$messages.addWebLinkTitle
                })
            };
        default:
            return {
                description: null,
                title: null
            };
    }
}
const $2da7380ffeeec786$var$messages = (0, $h82at.defineMessages)({
    addConfluenceContainerTitle: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-confluence-space-title",
        defaultMessage: "Confluence space"
    },
    confluenceContainerDescription: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-confluence-space-description",
        defaultMessage: "Create a knowledge bank"
    },
    addLoomContainerTitle: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-loom-space-title",
        defaultMessage: "Loom space"
    },
    loomSpaceDescription: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-loom-space-description",
        defaultMessage: "Share async updates"
    },
    addJiraProjectTitle: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-jira-project-title",
        defaultMessage: "Jira project"
    },
    jiraProjectDescription: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-jira-project-description",
        defaultMessage: "Plan out project tasks"
    },
    addWebLinkTitle: {
        id: "ptc-directory.team-profile-page.team-containers.create.add-web-link-title",
        defaultMessage: "Add any web link"
    }
});


const $9c9c7c8edc0a486e$var$styles = {
    card: "_4cvr1h6o _1bsb1osq",
    container: "_2rkoy0do _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _d0altlke",
    iconWrapper: "_2rko12b0 _12y3e4h9 _12ji1l7x _1qu2gq9o _syaz1rpy _4cvx1l7x _ksodnqa1"
};
const $9c9c7c8edc0a486e$var$AddContainerCardWrapper = ({ children: children, onClick: onClick })=>{
    const [hovered, setHovered] = (0, $42omo.useState)(false);
    const handleMouseEnter = ()=>setHovered(true);
    const handleMouseLeave = ()=>setHovered(false);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        backgroundColor: hovered ? 'elevation.surface.hovered' : 'elevation.surface.sunken',
        xcss: $9c9c7c8edc0a486e$var$styles.container,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: onClick,
        children: children
    });
};
const $9c9c7c8edc0a486e$export$7f436a9048e9eef4 = ({ containerType: containerType, onAddAContainerClick: onAddAContainerClick, isLoading: isLoading = false, canCreateContainers: canCreateContainers = false })=>{
    const { description: description, icon: icon, title: title } = (0, $31Vvl.getContainerProperties)({
        containerType: containerType,
        iconSize: (0, $dh538.fg)('enable_medium_size_icons_for_team_link_cards') ? 'medium' : undefined,
        isEmptyContainer: true
    });
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)((0, $062849b5172bd26b$export$b7a75d9378054329), {
        containerType: containerType
    });
    return /*#__PURE__*/ (0, $l998X.jsx)($9c9c7c8edc0a486e$var$AddContainerCardWrapper, {
        onClick: onAddAContainerClick,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.100",
            xcss: $9c9c7c8edc0a486e$var$styles.card,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $9c9c7c8edc0a486e$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                        label: "Add a container",
                        appearance: "subtle",
                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                                ...iconProps,
                                size: "small"
                            }),
                        testId: "add-icon",
                        onClick: (e)=>{
                            onAddAContainerClick(e);
                            e.stopPropagation();
                        }
                    })
                }),
                canCreateContainers ? /*#__PURE__*/ (0, $l998X.jsx)((0, $2da7380ffeeec786$export$cd6d34d857ce4eca), {
                    type: containerType
                }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                    ...(0, $dh538.fg)('enable_medium_size_icons_for_team_link_cards') ? {
                        space: 'space.025'
                    } : {},
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                            maxLines: 1,
                            weight: "medium",
                            color: "color.text",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                            gap: "space.050",
                            alignItems: "center",
                            children: [
                                icon,
                                /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $9c9c7c8edc0a486e$export$a1480278fb6646ef = ({ containers: containers, onAddAContainerClick: onAddAContainerClick, CustomAddContainerCard: CustomAddContainerCard, canCreateContainers: canCreateContainers })=>{
    const AddContainerCardComponent = CustomAddContainerCard ?? $9c9c7c8edc0a486e$export$7f436a9048e9eef4;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            containers.Jira.canAdd && /*#__PURE__*/ (0, $l998X.jsx)(AddContainerCardComponent, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Jira'),
                containerType: "JiraProject",
                isLoading: containers.Jira.isLoading,
                canCreateContainers: canCreateContainers
            }),
            containers.Confluence.canAdd && /*#__PURE__*/ (0, $l998X.jsx)(AddContainerCardComponent, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Confluence'),
                containerType: "ConfluenceSpace",
                isLoading: containers.Confluence.isLoading,
                canCreateContainers: canCreateContainers
            }),
            containers.Loom.canAdd && /*#__PURE__*/ (0, $l998X.jsx)(AddContainerCardComponent, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Loom'),
                containerType: "LoomSpace",
                isLoading: containers.Loom.isLoading,
                canCreateContainers: canCreateContainers
            }),
            containers.WebLink.canAdd && /*#__PURE__*/ (0, $l998X.jsx)(AddContainerCardComponent, {
                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'WebLink'),
                containerType: "WebLink",
                canCreateContainers: canCreateContainers
            })
        ]
    });
};





parcelRequire("42omo");


var $aqrhZ = parcelRequire("aqrhZ");


const $c26279cf8f73c062$var$DisconnectDialogLazyInner = (0, $aqrhZ.lazyForPaint)(()=>(parcelRequire("2Pqp7")).then(({ DisconnectDialog: DisconnectDialog })=>DisconnectDialog));
const $c26279cf8f73c062$export$3f4d3ee9eb71a228 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $aqrhZ.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $l998X.jsx)($c26279cf8f73c062$var$DisconnectDialogLazyInner, {
            ...props
        })
    });


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");







var $cO1el = parcelRequire("cO1el");








/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");


var $gj7hi = parcelRequire("gj7hi");




var $6cc5bf9e5f0c1b3b$exports = {};
$6cc5bf9e5f0c1b3b$exports = new URL("NoProductAccess.a65d0283.svg", import.meta.url).toString();


const $536c25e2a1eaecbd$var$styles = {
    icon: "_1ul9ys9h _p12fys9h"
};
function $536c25e2a1eaecbd$export$bf513868cd2f920f() {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $536c25e2a1eaecbd$var$styles.icon,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($6cc5bf9e5f0c1b3b$exports))),
            alt: ""
        })
    });
}


const $3dedcd9c7ca34a19$var$styles = {
    emptyStateContainer: "_2rko12b0 _189ee4h9 _1h6d1l7x _18zrpxbi _1rjcpxbi _12y3e4h9 _12ji1l7x _1qu2nqa1"
};
const $3dedcd9c7ca34a19$export$ecd1a08b364becd6 = ()=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
        space: "space.100",
        xcss: $3dedcd9c7ca34a19$var$styles.emptyStateContainer,
        testId: "team-containers-no-product-access-state",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            space: "space.200",
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $536c25e2a1eaecbd$export$bf513868cd2f920f), {}),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                        space: "space.200",
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                    ...$3dedcd9c7ca34a19$var$messages.teamContainerEmptyStateTitle
                                })
                            }),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                ...$3dedcd9c7ca34a19$var$messages.teamContainerEmptyStateDescription
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $3dedcd9c7ca34a19$var$messages = (0, $h82at.defineMessages)({
    teamContainerEmptyStateTitle: {
        id: "ptc.team-profile-page.team-containers.empty-state.title",
        defaultMessage: "Add the places your team works"
    },
    teamContainerEmptyStateDescription: {
        id: "ptc.team-profile-page.team-containers.empty-state.description",
        defaultMessage: "Your team can link their Jira projects, Confluence spaces here to show where they work"
    }
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 








var $1cfRh = parcelRequire("1cfRh");





var $1Whri = parcelRequire("1Whri");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $hmuev = parcelRequire("hmuev");


var $8tdj3 = parcelRequire("8tdj3");


var $9VJDA = parcelRequire("9VJDA");


var $2Nwuj = parcelRequire("2Nwuj");





var $auNCB = parcelRequire("auNCB");















var $3gadb = parcelRequire("3gadb");


var $bnTdW = parcelRequire("bnTdW");


var $jOrEm = parcelRequire("jOrEm");


var $2OhPQ = parcelRequire("2OhPQ");





var $kMNTc = parcelRequire("kMNTc");

/* team-link-card-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 


parcelRequire("42omo");






const $1d54835e6da1382c$var$styles = {
    anchorWithUnderline: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnx8stv _jf4cnqa1 _30l3i7uo"
};
const $1d54835e6da1382c$export$ed2948fef4767d5d = ({ isTeamLensInHomeEnabled: isTeamLensInHomeEnabled, isOpenWebLinkInNewTabEnabled: isOpenWebLinkInNewTabEnabled, link: link = '#', handleLinkClick: handleLinkClick, title: title })=>{
    return isTeamLensInHomeEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        xcss: $1d54835e6da1382c$var$styles.anchorWithUnderline,
        href: link,
        onClick: handleLinkClick,
        testId: "team-link-card-linkable-content",
        target: isOpenWebLinkInNewTabEnabled ? '_blank' : '_self',
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            maxLines: 1,
            weight: "medium",
            color: "color.text",
            children: title
        })
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
        maxLines: 1,
        weight: "medium",
        color: "color.text",
        children: title
    });
};


const $cef8474127ba13ca$var$styles = {
    container: "_2rkoy0do _1h6d8yml _12y3e4h9 _12ji1l7x _1qu2nqa1 _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi _syazi7uo _bfhkhp5a _irr319i6",
    card: "_4cvr1h6o _1bsb1osq",
    anchor: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _2rkoy0do _1bsb1osq _syazi7uo _1053i7uo _1hvwdkaa _nt751v1w _49pcnqa1 _1bg4v77o _30l3i7uo",
    anchorNoUnderline: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _30l3i7uo",
    anchorWithExternalLinkIcon: "_1e0c1txw _4cvr1h6o _1bah1yb4",
    iconWrapper: "_1bsbzwfg _4t3izwfg _1ul9zwfg _1tkezwfg",
    crossIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug",
    showMoreIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug",
    linkableContent: "_16jlkb7n _1o9zkb7n _i0dlf1ug",
    externalLinkIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u0u2gc"
};
const $cef8474127ba13ca$var$renderContainerTypeTextWithSeparator = (containerTypeText, description)=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            containerTypeText && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtle",
                children: containerTypeText
            }),
            containerTypeText && description && /*#__PURE__*/ (0, $l998X.jsx)((0, $jOrEm.Separator), {}),
            description && /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                size: "small",
                color: "color.text.subtle",
                children: description
            })
        ]
    });
};
const $cef8474127ba13ca$export$281f9ee6597a4098 = ({ containerType: containerType, title: title, containerIcon: containerIcon, link: link, containerId: containerId, containerTypeProperties: containerTypeProperties, onDisconnectButtonClick: onDisconnectButtonClick, onEditLinkClick: onEditLinkClick, iconsLoading: iconsLoading, iconHasLoaded: iconHasLoaded, openInNewTab: openInNewTab, isReadOnly: isReadOnly, hideSubTextIcon: hideSubTextIcon })=>{
    const { description: description, icon: icon, containerTypeText: containerTypeText } = (0, $31Vvl.getContainerProperties)({
        containerType: containerType,
        iconSize: 'medium',
        containerTypeProperties: containerTypeProperties
    });
    const [hovered, setHovered] = (0, $42omo.useState)(false);
    const [focused, setFocused] = (0, $42omo.useState)(false);
    const [showCloseIcon, setShowCloseIcon] = (0, $42omo.useState)(false);
    const [isDropdownOpen, setIsDropdownOpen] = (0, $42omo.useState)(false);
    const [showKeyboardFocus, setShowKeyboardFocus] = (0, $42omo.useState)(false);
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const isOpenWebLinkInNewTabEnabled = containerType === 'WebLink';
    const handleMouseEnter = ()=>{
        if (isReadOnly) return;
        setHovered(true);
        if (containerType !== 'WebLink') setShowCloseIcon(true);
    };
    const handleFocus = ()=>{
        if (isReadOnly) return;
        setFocused(true);
        if (containerType !== 'WebLink') setShowCloseIcon(true);
    };
    const handleBlur = ()=>{
        setFocused(false);
        if (containerType !== 'WebLink' && !hovered) setShowCloseIcon(false);
    };
    const handleMouseLeave = ()=>{
        setHovered(false);
        if (containerType !== 'WebLink' && !focused) setShowCloseIcon(false);
    };
    const handleIconClick = ()=>{
        if ((0, $dh538.fg)('fix_team_link_card_a11y')) setShowKeyboardFocus(false);
    };
    const handleKeyDown = (e)=>{
        if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Tab' || e.key === 'Escape') && (0, $dh538.fg)('fix_team_link_card_a11y')) setShowKeyboardFocus(true);
    };
    const handleLinkClick = (e)=>{
        e.stopPropagation();
        const baseAttributes = {
            container: containerType,
            containerId: containerId
        };
        const attributes = containerType === 'WebLink' && link ? {
            containerSelected: {
                ...baseAttributes,
                linkDomain: (0, $kMNTc.getDomainFromLinkUri)(link)
            }
        } : {
            containerSelected: baseAttributes
        };
        fireEvent('ui.container.clicked.teamContainer', attributes);
        if (openInNewTab || isOpenWebLinkInNewTabEnabled) {
            e.preventDefault();
            window.open(link || '#', '_blank', 'noopener, noreferrer');
        }
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: $cef8474127ba13ca$var$styles.container,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyDown: handleKeyDown,
        testId: "team-link-card-inner",
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $u9agA.default), {
            space: "space.150",
            xcss: $cef8474127ba13ca$var$styles.card,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $bnTdW.ContainerIcon), {
                    containerType: containerType,
                    title: title,
                    containerIcon: containerIcon,
                    size: "medium",
                    iconsLoading: iconsLoading,
                    iconHasLoaded: iconHasLoaded
                }),
                (0, $dh538.fg)('fix_team_link_card_a11y') ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default), {
                            xcss: (0, $1Whri.cx)($cef8474127ba13ca$var$styles.anchor, $cef8474127ba13ca$var$styles.anchorNoUnderline, isOpenWebLinkInNewTabEnabled && $cef8474127ba13ca$var$styles.anchorWithExternalLinkIcon),
                            href: link || '#',
                            onClick: handleLinkClick,
                            testId: "team-link-card-linkable-content",
                            target: isOpenWebLinkInNewTabEnabled ? '_blank' : '_self',
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1d54835e6da1382c$export$ed2948fef4767d5d), {
                                            isTeamLensInHomeEnabled: true,
                                            isOpenWebLinkInNewTabEnabled: isOpenWebLinkInNewTabEnabled,
                                            link: link || '#',
                                            handleLinkClick: handleLinkClick,
                                            title: title
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                            gap: "space.050",
                                            alignItems: "center",
                                            children: [
                                                !hideSubTextIcon ? icon : null,
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                                    space: "space.050",
                                                    alignBlock: "center",
                                                    children: $cef8474127ba13ca$var$renderContainerTypeTextWithSeparator(containerTypeText, description)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isOpenWebLinkInNewTabEnabled && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                    xcss: $cef8474127ba13ca$var$styles.externalLinkIconWrapper,
                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
                                        label: formatMessage($cef8474127ba13ca$var$messages.linkExternalIconLabel),
                                        "aria-hidden": "true",
                                        size: "small"
                                    })
                                })
                            ]
                        }),
                        !isReadOnly && /*#__PURE__*/ (0, $l998X.jsx)((0, $2OhPQ.TeamLinkCardActions), {
                            containerType: containerType,
                            title: title,
                            containerId: containerId,
                            hovered: hovered,
                            focused: focused,
                            isDropdownOpen: isDropdownOpen,
                            showKeyboardFocus: showKeyboardFocus,
                            onDisconnectButtonClick: ()=>{
                                handleIconClick();
                                onDisconnectButtonClick();
                            },
                            onEditLinkClick: ()=>{
                                handleIconClick();
                                onEditLinkClick?.();
                            },
                            onDropdownOpenChange: setIsDropdownOpen
                        })
                    ]
                }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $cef8474127ba13ca$var$styles.linkableContent,
                            testId: "team-link-card-linkable-content",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                href: link || '#',
                                appearance: "subtle",
                                onClick: handleLinkClick,
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $1d54835e6da1382c$export$ed2948fef4767d5d), {
                                            isTeamLensInHomeEnabled: true,
                                            isOpenWebLinkInNewTabEnabled: isOpenWebLinkInNewTabEnabled,
                                            link: link || '#',
                                            handleLinkClick: handleLinkClick,
                                            title: title
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                                            gap: "space.050",
                                            alignItems: "center",
                                            children: [
                                                !hideSubTextIcon ? icon : null,
                                                /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                                                    space: "space.050",
                                                    alignBlock: "center",
                                                    children: $cef8474127ba13ca$var$renderContainerTypeTextWithSeparator(containerTypeText, description)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        showCloseIcon && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $cef8474127ba13ca$var$styles.crossIconWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
                                content: formatMessage($cef8474127ba13ca$var$messages.disconnectTooltip),
                                position: "top",
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                    label: `disconnect the container ${title}`,
                                    appearance: "subtle",
                                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                                            ...iconProps,
                                            size: "small"
                                        }),
                                    spacing: "compact",
                                    onClick: (e)=>{
                                        e.preventDefault();
                                        e.stopPropagation();
                                        onDisconnectButtonClick();
                                        fireEvent('ui.button.clicked.containerUnlinkButton', {
                                            containerSelected: {
                                                container: containerType,
                                                containerId: containerId
                                            }
                                        });
                                    }
                                })
                            })
                        }),
                        containerType === 'WebLink' && (hovered || isDropdownOpen) && /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                            xcss: $cef8474127ba13ca$var$styles.showMoreIconWrapper,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
                                trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                                        ref: triggerRef,
                                        ...triggerProps,
                                        label: `more options for ${title}`,
                                        appearance: "subtle",
                                        icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                                                ...iconProps,
                                                size: "small"
                                            }),
                                        spacing: "compact"
                                    }),
                                placement: "bottom-end",
                                shouldRenderToParent: true,
                                onOpenChange: (attrs)=>{
                                    setIsDropdownOpen(attrs.isOpen);
                                },
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $ahaN7.default), {
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                e.stopPropagation();
                                                onEditLinkClick?.();
                                                fireEvent('ui.button.clicked.containerEditLinkButton', {
                                                    containerSelected: {
                                                        container: containerType,
                                                        containerId: containerId
                                                    }
                                                });
                                            },
                                            children: formatMessage($cef8474127ba13ca$var$messages.editLink)
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                e.stopPropagation();
                                                onDisconnectButtonClick();
                                                fireEvent('ui.button.clicked.containerUnlinkButton', {
                                                    containerSelected: {
                                                        container: containerType,
                                                        containerId: containerId
                                                    }
                                                });
                                            },
                                            children: formatMessage($cef8474127ba13ca$var$messages.removeLink)
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $cef8474127ba13ca$var$messages = (0, $h82at.defineMessages)({
    disconnectTooltip: {
        id: "ptc-directory.team-containers.disconnect-button.tooltip",
        defaultMessage: "Disconnect"
    },
    editLink: {
        id: "ptc-directory.team-containers.edit-link",
        defaultMessage: "Edit link"
    },
    removeLink: {
        id: "ptc-directory.team-containers.remove-link",
        defaultMessage: "Remove"
    },
    linkExternalIconLabel: {
        id: "ptc-directory.team-containers.link-external-icon-label",
        defaultMessage: "Open link in new tab"
    }
});


const $4adb5a7a7d2f1b64$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, #FFFFFF)";
const $4adb5a7a7d2f1b64$export$72502e51aebdd94e = "var(--ds-icon-subtle, #505258)";
const $4adb5a7a7d2f1b64$export$33f8090aba665a84 = 4;
const $4adb5a7a7d2f1b64$export$73c2d2b9b49926f5 = ({ teamId: teamId, onAddAContainerClick: onAddAContainerClick, onEditContainerClick: onEditContainerClick, components: components, userId: userId, cloudId: cloudId, filterContainerId: filterContainerId, isDisplayedOnProfileCard: isDisplayedOnProfileCard, isReadOnly: isReadOnly, onError: onError, maxNumberOfContainersToShow: maxNumberOfContainersToShow = $4adb5a7a7d2f1b64$export$33f8090aba665a84, elemBeforeCards: elemBeforeCards, hideSubTextIcon: hideSubTextIcon })=>{
    const { unlinkError: unlinkError } = (0, $hogmh.useTeamContainers)(teamId);
    const { teamLinks: teamLinks, removeTeamLink: removeTeamLink, iconsLoading: iconsLoading, iconHasLoaded: iconHasLoaded, hasError: hasError, isLoading: linksLoading } = (0, $aYWXT.useTeamLinksAndContainers)(teamId, true);
    const [_, actions] = (0, $hogmh.useTeamContainersHook)();
    const [showMore, setShowMore] = (0, $42omo.useState)(false);
    const [isDisconnectDialogOpen, setIsDisconnectDialogOpen] = (0, $42omo.useState)(false);
    const [selectedContainerDetails, setSelectedContainerDetails] = (0, $42omo.useState)();
    const [filteredTeamLinks, setFilteredTeamLinks] = (0, $42omo.useState)(teamLinks);
    const [canAddContainer, setCanAddContainer] = (0, $42omo.useState)({
        Jira: false,
        Confluence: false,
        Loom: false,
        WebLink: false
    });
    const [containers] = (0, $3ZPUI.useCreateContainers)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)();
    const { data: productPermissions, loading: productPermissionIsLoading } = (0, $kdU21.useProductPermissions)({
        userId: userId,
        cloudId: cloudId,
        permissionsToCheck: {
            jira: [
                'CREATE_PROJECT',
                'manage',
                'write'
            ],
            loom: [
                'write',
                'manage'
            ],
            confluence: [
                'write',
                'manage',
                'CREATE_SPACE'
            ]
        },
        options: {
            enabled: (0, $dh538.fg)('migrate-product-permissions')
        }
    });
    const { data: productPermissionsOld, loading: productPermissionIsLoadingOld } = (0, $g1rvx.useProductPermissions)({
        userId: userId,
        cloudId: cloudId
    }, {
        enabled: !(0, $dh538.fg)('migrate-product-permissions')
    });
    (0, $b07c34dd4d8ba0b7$export$2a2e523635b9b98e)(teamId);
    const hasPermissionToCreateContainer = (0, $42omo.useMemo)(()=>{
        if (!productPermissions) return false;
        const getPermission = (product, permission)=>{
            return productPermissions && (0, $iBtX5.hasProductPermission)(productPermissions, product, permission);
        };
        return getPermission('confluence', [
            'CREATE_SPACE'
        ]) || getPermission('jira', [
            'CREATE_PROJECT'
        ]) || getPermission('loom', [
            'write'
        ]);
    }, [
        productPermissions
    ]);
    (0, $42omo.useEffect)(()=>{
        if (isDisplayedOnProfileCard && filterContainerId) setFilteredTeamLinks(teamLinks.filter((container)=>container.id !== filterContainerId));
        else setFilteredTeamLinks(teamLinks);
    }, [
        teamLinks,
        isDisplayedOnProfileCard,
        filterContainerId
    ]);
    (0, $42omo.useEffect)(()=>{
        const containersToCheck = filteredTeamLinks;
        if (containersToCheck.length > maxNumberOfContainersToShow || isDisplayedOnProfileCard || isReadOnly) setCanAddContainer({
            Jira: false,
            Confluence: false,
            Loom: false,
            WebLink: false
        });
        else {
            const containerExists = (type)=>containersToCheck.some((container)=>container.type === type);
            const showContainer = (containerExists, product)=>{
                if (containerExists) return false;
                if ((0, $dh538.fg)('migrate-product-permissions')) return productPermissions && (0, $iBtX5.hasProductPermission)(productPermissions, product, []) || false;
                return productPermissionsOld && (0, $cK1S8.hasProductPermission)(productPermissionsOld, product, []) || false;
            };
            setCanAddContainer({
                Jira: showContainer(containerExists('JiraProject'), 'jira'),
                Confluence: showContainer(containerExists('ConfluenceSpace'), 'confluence'),
                Loom: showContainer(containerExists('LoomSpace'), 'loom'),
                WebLink: !containerExists('WebLink')
            });
        }
    }, [
        isDisplayedOnProfileCard,
        productPermissions,
        productPermissionsOld,
        filteredTeamLinks,
        maxNumberOfContainersToShow,
        isReadOnly
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onError) {
            if (hasError) onError(hasError);
            else if (unlinkError) onError(unlinkError);
        }
    }, [
        hasError,
        unlinkError,
        onError
    ]);
    const handleShowMore = ()=>{
        setShowMore(!showMore);
    };
    const handleOpenDisconnectDialog = (0, $42omo.useCallback)((containerDetails)=>{
        setSelectedContainerDetails(containerDetails);
        setIsDisconnectDialogOpen(true);
        fireEvent('track.unlinkContainerDialog.opened', {
            teamId: teamId
        });
    }, [
        teamId,
        fireEvent
    ]);
    const handleEditContainerClick = (0, $42omo.useCallback)((container)=>{
        if (container.type === 'WebLink' && onEditContainerClick) onEditContainerClick(container.id, container.link || '', container.name);
    }, [
        onEditContainerClick
    ]);
    const LinkedContainerCardComponent = components?.ContainerCard || (0, $cef8474127ba13ca$export$281f9ee6597a4098);
    const handleDisconnect = (0, $42omo.useCallback)(async (containerId)=>{
        const removedContainer = filteredTeamLinks.find((container)=>container.id === containerId);
        if (removedContainer) await removeTeamLink(removedContainer);
        else await actions.unlinkTeamContainers(teamId, containerId);
        setIsDisconnectDialogOpen(false);
        if (unlinkError) fireEvent('track.teamContainerUnlinked.failed', {});
        else {
            if ((0, $dh538.fg)('space-team_linking_invites_fg')) (0, $cHq3C.spaceInviteScheduler).cancelInvite(teamId, containerId);
            fireEvent('track.teamContainerUnlinked.succeeded', {
                containerRemoved: {
                    containerId: removedContainer?.id,
                    container: removedContainer?.type
                },
                teamId: teamId
            });
        }
    }, [
        actions,
        filteredTeamLinks,
        removeTeamLink,
        teamId,
        unlinkError,
        fireEvent
    ]);
    const TeamContainersSkeletonComponent = components?.TeamContainersSkeleton || (0, $c6a66ab9fd93fec3$export$b4d5d8f3bbe29b5f);
    const hasNoPermissions = (0, $42omo.useMemo)(()=>{
        if ((0, $dh538.fg)('migrate-product-permissions')) return productPermissions && !(0, $iBtX5.hasProductPermission)(productPermissions, 'jira') && !(0, $iBtX5.hasProductPermission)(productPermissions, 'confluence') && !(0, $iBtX5.hasProductPermission)(productPermissions, 'loom');
        return productPermissionsOld && !(0, $cK1S8.hasProductPermission)(productPermissionsOld, 'jira') && !(0, $cK1S8.hasProductPermission)(productPermissionsOld, 'confluence') && !(0, $cK1S8.hasProductPermission)(productPermissionsOld, 'loom');
    }, [
        productPermissions,
        productPermissionsOld
    ]);
    const hasNoContainers = (0, $42omo.useMemo)(()=>{
        return filteredTeamLinks.length === 0;
    }, [
        filteredTeamLinks
    ]);
    const isLoading = (0, $42omo.useMemo)(()=>{
        if (linksLoading) return true;
        if ((0, $dh538.fg)('migrate-product-permissions')) return productPermissionIsLoading;
        return productPermissionIsLoadingOld;
    }, [
        linksLoading,
        productPermissionIsLoading,
        productPermissionIsLoadingOld
    ]);
    const availableContainers = (0, $42omo.useMemo)(()=>{
        const getAvailableContainer = (productKey)=>({
                canAdd: canAddContainer?.[productKey],
                isLoading: containers?.[productKey]?.isLoading
            });
        return {
            Jira: getAvailableContainer('Jira'),
            Confluence: getAvailableContainer('Confluence'),
            Loom: getAvailableContainer('Loom'),
            WebLink: getAvailableContainer('WebLink')
        };
    }, [
        canAddContainer,
        containers
    ]);
    if (isLoading) return /*#__PURE__*/ (0, $l998X.jsx)(TeamContainersSkeletonComponent, {
        numberOfContainers: maxNumberOfContainersToShow
    });
    if (hasNoContainers) {
        if (components?.TeamContainersEmptyState) {
            const EmptyStateComponent = components.TeamContainersEmptyState;
            return /*#__PURE__*/ (0, $l998X.jsx)(EmptyStateComponent, {
                hasNoPermissions: !!hasNoPermissions
            });
        } else if (!isDisplayedOnProfileCard && hasNoPermissions) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3dedcd9c7ca34a19$export$ecd1a08b364becd6), {});
    }
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                space: "space.200",
                children: [
                    (()=>{
                        const GridComponent = components?.Grid || (0, $cwkWT.default);
                        return /*#__PURE__*/ (0, $l998X.jsxs)(GridComponent, {
                            templateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                            gap: isDisplayedOnProfileCard ? 'space.0' : 'space.100',
                            children: [
                                elemBeforeCards && (()=>{
                                    const ElemBeforeCards = elemBeforeCards;
                                    return /*#__PURE__*/ (0, $l998X.jsx)(ElemBeforeCards, {});
                                })(),
                                filteredTeamLinks.slice(0, maxNumberOfContainersToShow).map((container)=>{
                                    return /*#__PURE__*/ (0, $l998X.jsx)(LinkedContainerCardComponent, {
                                        containerType: container.type,
                                        containerTypeProperties: container.containerTypeProperties,
                                        title: container.name,
                                        containerIcon: container.icon || undefined,
                                        link: container.link || undefined,
                                        containerId: container.id,
                                        iconsLoading: iconsLoading,
                                        iconHasLoaded: iconHasLoaded,
                                        isReadOnly: isReadOnly,
                                        hideSubTextIcon: hideSubTextIcon,
                                        onDisconnectButtonClick: ()=>handleOpenDisconnectDialog({
                                                containerId: container.id,
                                                containerType: container.type,
                                                containerName: container.name
                                            }),
                                        onEditLinkClick: ()=>handleEditContainerClick(container)
                                    }, container.id);
                                }),
                                (0, $9c9c7c8edc0a486e$export$a1480278fb6646ef)({
                                    containers: availableContainers,
                                    onAddAContainerClick: onAddAContainerClick,
                                    CustomAddContainerCard: components?.AddContainerCard,
                                    canCreateContainers: hasPermissionToCreateContainer
                                }),
                                showMore && filteredTeamLinks.slice(maxNumberOfContainersToShow).map((container)=>{
                                    return /*#__PURE__*/ (0, $l998X.jsx)(LinkedContainerCardComponent, {
                                        containerType: container.type,
                                        containerTypeProperties: container.containerTypeProperties,
                                        title: container.name,
                                        containerId: container.id,
                                        containerIcon: container.icon || undefined,
                                        link: container.link || undefined,
                                        iconsLoading: iconsLoading,
                                        iconHasLoaded: iconHasLoaded,
                                        isReadOnly: isReadOnly,
                                        hideSubTextIcon: hideSubTextIcon,
                                        onDisconnectButtonClick: ()=>handleOpenDisconnectDialog({
                                                containerId: container.id,
                                                containerType: container.type,
                                                containerName: container.name
                                            }),
                                        onEditLinkClick: ()=>handleEditContainerClick(container)
                                    }, container.id);
                                })
                            ]
                        });
                    })(),
                    filteredTeamLinks.length > maxNumberOfContainersToShow && /*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ccHMk.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            onClick: handleShowMore,
                            children: showMore ? /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                ...$4adb5a7a7d2f1b64$var$messages.showLess
                            }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                                ...$4adb5a7a7d2f1b64$var$messages.showMore
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6xdDU.default), {
                children: isDisconnectDialogOpen && selectedContainerDetails && /*#__PURE__*/ (0, $l998X.jsx)((0, $c26279cf8f73c062$export$3f4d3ee9eb71a228), {
                    containerName: selectedContainerDetails.containerName,
                    containerType: selectedContainerDetails.containerType,
                    onClose: ()=>setIsDisconnectDialogOpen(false),
                    onDisconnect: ()=>handleDisconnect(selectedContainerDetails.containerId)
                })
            })
        ]
    });
};
const $4adb5a7a7d2f1b64$var$messages = (0, $h82at.defineMessages)({
    showMore: {
        id: "ptc-directory.team-profile-page.team-containers.show-more",
        defaultMessage: "Show more"
    },
    showLess: {
        id: "ptc-directory.team-profile-page.team-containers.show-less",
        defaultMessage: "Show less"
    }
});
module.exports["TeamContainers"] = $4adb5a7a7d2f1b64$export$73c2d2b9b49926f5;

});

parcelRegister("iBtX5", function(module, exports) {
const $49d505ddbcfe4978$export$a2eea90ce05a9f1c = (permissions, product, permissionIds)=>{
    if (!permissions[product]) return false;
    if ((!permissionIds || permissionIds.length === 0) && permissions[product]) return Object.values(permissions[product] || {}).some((value)=>value === true);
    return permissionIds?.some((permissionId)=>permissions[product]?.[permissionId]);
};
module.exports["hasProductPermission"] = $49d505ddbcfe4978$export$a2eea90ce05a9f1c;

});

parcelRegister("kdU21", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $11f3ff053e659fe4$var$JIRA_SUB_PRODUCTS = [
    'jira',
    'jira-core',
    'jira-software',
    'jira-servicedesk',
    'jira-product-discovery'
];
const $11f3ff053e659fe4$export$29429bc4d26dfcf8 = ({ url: url, query: query, variables: variables })=>{
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
};
const $11f3ff053e659fe4$export$98fa14561e3049ec = ({ url: url, body: body })=>{
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json'
        },
        body: body
    });
};
const $11f3ff053e659fe4$export$e16fe80afd1ad74c = (cloudId, userId, productPermissions)=>{
    const body = productPermissions.reduce((acc, productPermission)=>{
        const permission = {
            permissionId: productPermission.permissionId,
            resourceId: '',
            principalId: `ari:cloud:identity::user/${userId}`,
            dontRequirePrincipalInSite: true
        };
        if (productPermission.product === 'jira') $11f3ff053e659fe4$var$JIRA_SUB_PRODUCTS.forEach((product)=>{
            acc.push({
                ...permission,
                resourceId: `ari:cloud:${product}::site/${cloudId}`
            });
        });
        else acc.push({
            ...permission,
            resourceId: `ari:cloud:${productPermission.product}::site/${cloudId}`
        });
        return acc;
    }, []);
    return JSON.stringify(body);
};


const $271938b51863a92c$export$544dab20dbe3f2e7 = (product, permissionId, cloudId)=>{
    if (product === 'jira' && permissionId === 'CREATE_PROJECT') return {
        type: 'graphql',
        url: '/gateway/api/graphql',
        query: `query CanCreateProject($cloudId: ID!) {
						jira {
							canPerform  (cloudId: $cloudId, type: CREATE_PROJECT) @optIn(to: "JiraAction")
						}
					}`,
        variables: {
            cloudId: cloudId
        },
        transformResponse: (response)=>{
            return {
                permissionId: 'CREATE_PROJECT',
                resourceId: 'jira',
                permitted: response?.data?.jira?.canPerform || false
            };
        }
    };
    else if (product === 'confluence' && permissionId === 'CREATE_SPACE') return {
        type: 'graphql',
        url: '/gateway/api/graphql',
        query: `query CanCreateConfluenceSpace($cloudId: ID) {
						siteOperations (cloudId: $cloudId) {
    						application
  						}
					}`,
        variables: {
            cloudId: cloudId
        },
        transformResponse: (response)=>{
            return {
                permissionId: 'CREATE_SPACE',
                resourceId: 'confluence',
                permitted: response?.data?.siteOperations?.application?.includes('create_space') || false
            };
        }
    };
};
const $271938b51863a92c$var$fetchPermissionFromDefaultEndpoint = async ({ cloudId: cloudId, userId: userId, productPermissions: productPermissions })=>{
    const response = await (0, $11f3ff053e659fe4$export$98fa14561e3049ec)({
        url: '/gateway/api/permissions/bulk/permitted',
        body: (0, $11f3ff053e659fe4$export$e16fe80afd1ad74c)(cloudId, userId, productPermissions)
    });
    if (!response.ok) {
        const errorBody = await response.json();
        const errorMessage = errorBody.message || errorBody.error || `HTTP error! status: ${response.status}`;
        throw new Error(`Failed to fetch product permissions with error ${errorMessage}`);
    }
    const bulkPermissions = await response.json();
    return bulkPermissions;
};
const $271938b51863a92c$var$fetchPermissionFromRestApi = async (endpoint)=>{
    if (!endpoint || endpoint.type !== 'rest') return;
    const res = await (0, $11f3ff053e659fe4$export$98fa14561e3049ec)({
        url: endpoint.url
    });
    const responseData = await res.json();
    return endpoint.transformResponse(responseData);
};
const $271938b51863a92c$var$fetchPermissionFromGraphql = async (endpoint)=>{
    if (!endpoint || endpoint.type !== 'graphql') return;
    const response = await (0, $11f3ff053e659fe4$export$29429bc4d26dfcf8)({
        url: endpoint.url,
        query: endpoint.query,
        variables: endpoint.variables
    });
    const responseData = await response.json();
    return endpoint.transformResponse(responseData);
};
const $271938b51863a92c$export$dcb450c551529da1 = async ({ permissionsToCheck: permissionsToCheck, cloudId: cloudId, userId: userId })=>{
    const apiCallPromises = [];
    const permissions = [];
    const productKeys = Object.keys(permissionsToCheck);
    const errors = [];
    const productPermissions = [];
    productKeys.forEach((productKey)=>permissionsToCheck[productKey]?.forEach(async (permission)=>{
            const endpoint = $271938b51863a92c$export$544dab20dbe3f2e7(productKey, permission, cloudId);
            if (endpoint) {
                if (endpoint.type === 'rest') apiCallPromises.push((async ()=>{
                    try {
                        const responseData = await $271938b51863a92c$var$fetchPermissionFromRestApi(endpoint);
                        if (responseData) permissions.push(responseData);
                    } catch (error) {
                        errors.push(new Error(`Error fetching product permissions with error ${error}`));
                        permissions.push({
                            permissionId: permission,
                            resourceId: productKey,
                            permitted: false
                        });
                    }
                })());
                else if (endpoint.type === 'graphql') apiCallPromises.push((async ()=>{
                    try {
                        const responseData = await $271938b51863a92c$var$fetchPermissionFromGraphql(endpoint);
                        if (responseData) permissions.push(responseData);
                    } catch (error) {
                        permissions.push({
                            permissionId: permission,
                            resourceId: productKey,
                            permitted: false
                        });
                        errors.push(new Error(`Error fetching product permissions with error ${error}`));
                    }
                })());
                else if (endpoint.type === 'default') productPermissions.push({
                    product: endpoint.payload.product,
                    permissionId: endpoint.payload.permissionId
                });
            } else productPermissions.push({
                product: productKey,
                permissionId: permission
            });
        }));
    if (productPermissions.length > 0) apiCallPromises.push((async ()=>{
        try {
            const bulkPermissions = await $271938b51863a92c$var$fetchPermissionFromDefaultEndpoint({
                cloudId: cloudId,
                userId: userId,
                productPermissions: productPermissions
            });
            permissions.push(...bulkPermissions);
        } catch (error) {
            errors.push(new Error(`Error fetching product permissions with error ${error}`));
        }
    })());
    await Promise.allSettled(apiCallPromises);
    return {
        permissions: permissions,
        errors: errors
    };
};


const $83cc7ad61bf4f552$export$69caceff42c0da80 = [
    'confluence',
    'jira',
    'loom'
];


const $e2f95f239ab54f09$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        (0, $83cc7ad61bf4f552$export$69caceff42c0da80).forEach((supportedProduct)=>{
            if (permission.resourceId.includes(supportedProduct)) acc[supportedProduct] = {
                ...acc[supportedProduct],
                [permission.permissionId]: acc[supportedProduct]?.[permission.permissionId] || permission.permitted
            };
        });
        return acc;
    }, {});
};


const $21a370a6c94ec1e0$var$actions = {
    getPermissions: ({ userId: userId, cloudId: cloudId, enabled: enabled, permissionsToCheck: permissionsToCheck })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading, permissions: permissions } = getState();
            if (isLoading || !userId || !cloudId || !enabled) return;
            const shouldFetch = !hasLoaded || permissionsToCheck.jira?.some((permissionId)=>permissions.jira?.[permissionId] === undefined) || permissionsToCheck.confluence?.some((permissionId)=>permissions.confluence?.[permissionId] === undefined) || permissionsToCheck.loom?.some((permissionId)=>permissions.loom?.[permissionId] === undefined);
            if (!shouldFetch) return;
            try {
                setState({
                    isLoading: true
                });
                const { permissions: permissions } = await (0, $271938b51863a92c$export$dcb450c551529da1)({
                    permissionsToCheck: permissionsToCheck,
                    cloudId: cloudId,
                    userId: userId
                });
                dispatch($21a370a6c94ec1e0$var$actions.setPermissions(permissions));
            } catch (error) {
                dispatch($21a370a6c94ec1e0$var$actions.setError(new Error('Failed to fetch product permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ getState: getState, setState: setState })=>{
            const newPermissions = (0, $e2f95f239ab54f09$export$7fe0bfa353103198)(permissions);
            const oldPermissions = getState().permissions;
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: {
                    jira: {
                        ...oldPermissions.jira,
                        ...newPermissions.jira
                    },
                    confluence: {
                        ...oldPermissions.confluence,
                        ...newPermissions.confluence
                    },
                    loom: {
                        ...oldPermissions.loom,
                        ...newPermissions.loom
                    }
                },
                permissionsResponse: permissions
            });
        }
};
const $21a370a6c94ec1e0$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {}
    },
    actions: $21a370a6c94ec1e0$var$actions,
    name: 'product-permissions'
});
const $21a370a6c94ec1e0$export$933ed92af1ed5de9 = (0, $9zUhf.createHook)($21a370a6c94ec1e0$var$Store);


const $5856de27861a3f68$export$5814f9544ee53f3b = ({ userId: userId, cloudId: cloudId, permissionsToCheck: permissionsToCheck, options: options })=>{
    const [state, { getPermissions: getPermissions }] = (0, $21a370a6c94ec1e0$export$933ed92af1ed5de9)();
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        getPermissions({
            cloudId: cloudId,
            userId: userId,
            enabled: options?.enabled ?? true,
            permissionsToCheck: permissionsToCheck || {
                jira: [
                    'manage',
                    'write'
                ],
                confluence: [
                    'manage',
                    'write'
                ],
                loom: [
                    'manage',
                    'write'
                ]
            }
        });
    }, [
        cloudId,
        options,
        getPermissions,
        userId,
        permissionsToCheck
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissions,
        error: state.error
    };
};
module.exports["useProductPermissions"] = $5856de27861a3f68$export$5814f9544ee53f3b;

});

parcelRegister("31Vvl", function(module, exports) {
/* get-container-properties.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $1Whri = parcelRequire("1Whri");


var $1bY7o = parcelRequire("1bY7o");


var $8tdj3 = parcelRequire("8tdj3");


var $gj7hi = parcelRequire("gj7hi");


var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $hWTBk = parcelRequire("hWTBk");


var $bjHDba = parcelRequire("bjHDba");

var $1bb75d114f5d6d80$exports = {};
$1bb75d114f5d6d80$exports = new URL("JiraProjectDiscovery.556db745.svg", import.meta.url).toString();


var $09ec6cdb17c1ce6a$exports = {};
$09ec6cdb17c1ce6a$exports = new URL("JiraServiceManagement.0b0134a3.svg", import.meta.url).toString();



var $dIk9b = parcelRequire("dIk9b");

const $c54f7acfc778f2e2$var$styles = {
    avatarWrapper: "_1bsb1tcg _4t3i1tcg",
    avatarMargin: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
    smallAvatarWrapper: "_1bsb7vkz _4t3i7vkz",
    smallAvatarMargin: "_195gidpf _1mouidpf",
    linkIconWrapper: "_2rkofajl _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _12ji1l7x _1qu2nqa1",
    linkAvatarWrapper: "_2rko1eiz _1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o _bfhki8nm"
};
const $c54f7acfc778f2e2$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    addConfluenceContainerTitle: {
        id: "ptc-directory.team-profile-page.team-containers.add-confluence-space-title",
        defaultMessage: "Add space"
    },
    confluenceContainerDescription: {
        id: "ptc-directory.team-profile-page.team-containers.add-confluence-space-description",
        defaultMessage: "Confluence"
    },
    addLoomSpace: {
        id: "ptc-directory.team-profile-page.team-containers.add-loom-space",
        defaultMessage: "Add Loom Space"
    },
    addJiraProject: {
        id: "ptc-directory.team-profile-page.team-containers.add-jira-project",
        defaultMessage: "Add Jira Project"
    },
    jiraProjectDescription: {
        id: "ptc-directory.team-profile-page.team-containers.add-jira-project-description",
        defaultMessage: "Jira"
    },
    loomSpaceDescription: {
        id: "ptc-directory.team-profile-page.team-containers.add-loom-space-description",
        defaultMessage: "Loom"
    },
    spaceContainerTextOverride: {
        id: "ptc-directory.team-profile-page.team-containers.space-container-text-override",
        defaultMessage: "Space"
    },
    emptyLinkContainerDescription: {
        id: "platform.teams.containers.empty-link-description",
        defaultMessage: "Add any link"
    },
    addLink: {
        id: "platform.teams.containers.add-link",
        defaultMessage: "Add Link"
    },
    linkContainerDescription: {
        id: "platform.teams.containers.link-title-description",
        defaultMessage: "Link"
    }
});
const $c54f7acfc778f2e2$var$getJiraIcon = (containerSubTypes)=>{
    switch(containerSubTypes){
        case 'PRODUCT_DISCOVERY':
            return 0, (/*@__PURE__*/$parcel$interopDefault($1bb75d114f5d6d80$exports));
        case 'SERVICE_DESK':
            return 0, (/*@__PURE__*/$parcel$interopDefault($09ec6cdb17c1ce6a$exports));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($bjHDba));
    }
};
const $c54f7acfc778f2e2$var$getJiraContainerProperties = ({ containerTypeProperties: containerTypeProperties, iconSize: iconSize = 'medium' })=>{
    const { subType: subType, name: name } = containerTypeProperties || {};
    const baseProperties = {
        description: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.jiraProjectDescription
        }),
        icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
            xcss: (0, $1Whri.cx)(iconSize === 'small' ? $c54f7acfc778f2e2$var$styles.smallAvatarWrapper : $c54f7acfc778f2e2$var$styles.avatarWrapper, iconSize === 'small' ? $c54f7acfc778f2e2$var$styles.smallAvatarMargin : $c54f7acfc778f2e2$var$styles.avatarMargin),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                src: $c54f7acfc778f2e2$var$getJiraIcon(subType),
                alt: "",
                testId: "jira-project-container-icon"
            })
        }),
        title: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.addJiraProject
        }),
        containerTypeText: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.spaceContainerTextOverride
        })
    };
    switch(subType){
        case 'PRODUCT_DISCOVERY':
        case 'SERVICE_DESK':
            return {
                ...baseProperties,
                containerTypeText: '',
                description: name || baseProperties.description
            };
        default:
            return baseProperties;
    }
};
const $c54f7acfc778f2e2$var$getWebLinkContainerProperties = ({ isEmptyContainer: isEmptyContainer, isDisplayedOnProfileCard: isDisplayedOnProfileCard })=>{
    return {
        description: isEmptyContainer ? /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: "medium",
            weight: "medium",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                ...$c54f7acfc778f2e2$export$defe85febe8b728c.emptyLinkContainerDescription
            })
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.linkContainerDescription
        }),
        icon: isEmptyContainer ? /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: (0, $1Whri.cx)($c54f7acfc778f2e2$var$styles.linkAvatarWrapper, $c54f7acfc778f2e2$var$styles.avatarMargin),
            testId: "team-link-card-globe-icon",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                label: "",
                size: "medium"
            })
        }) : isDisplayedOnProfileCard ? /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8tdj3))), {
            label: "",
            size: "small",
            testId: "team-link-card-external-link-icon"
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
            xcss: $c54f7acfc778f2e2$var$styles.linkIconWrapper,
            testId: "team-link-card-globe-icon",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                label: "",
                size: "small"
            })
        }),
        title: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.addLink
        }),
        containerTypeText: null
    };
};
const $c54f7acfc778f2e2$export$4fa7913af1c65224 = ({ containerType: containerType, iconSize: iconSize = 'medium', containerTypeProperties: containerTypeProperties, isEmptyContainer: isEmptyContainer, isDisplayedOnProfileCard: isDisplayedOnProfileCard })=>{
    switch(containerType){
        case 'ConfluenceSpace':
            return {
                description: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.confluenceContainerDescription
                }),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    xcss: (0, $1Whri.cx)(iconSize === 'small' ? $c54f7acfc778f2e2$var$styles.smallAvatarWrapper : $c54f7acfc778f2e2$var$styles.avatarWrapper, iconSize === 'small' ? $c54f7acfc778f2e2$var$styles.smallAvatarMargin : $c54f7acfc778f2e2$var$styles.avatarMargin),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($hWTBk))),
                        alt: "",
                        testId: "confluence-space-container-icon"
                    })
                }),
                title: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.addConfluenceContainerTitle
                }),
                containerTypeText: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.spaceContainerTextOverride
                })
            };
        case 'LoomSpace':
            return {
                description: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.loomSpaceDescription
                }),
                icon: /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    xcss: (0, $1Whri.cx)(iconSize === 'small' ? $c54f7acfc778f2e2$var$styles.smallAvatarWrapper : $c54f7acfc778f2e2$var$styles.avatarWrapper, iconSize === 'small' ? $c54f7acfc778f2e2$var$styles.smallAvatarMargin : $c54f7acfc778f2e2$var$styles.avatarMargin),
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($dIk9b))),
                        alt: "",
                        testId: "loom-space-container-icon"
                    })
                }),
                title: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.addLoomSpace
                }),
                containerTypeText: /*#__PURE__*/ (0, $l998X.jsx)((0, $hiS1z.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.spaceContainerTextOverride
                })
            };
        case 'JiraProject':
            return $c54f7acfc778f2e2$var$getJiraContainerProperties({
                containerTypeProperties: containerTypeProperties,
                iconSize: iconSize
            });
        case 'WebLink':
            return $c54f7acfc778f2e2$var$getWebLinkContainerProperties({
                isEmptyContainer: isEmptyContainer,
                isDisplayedOnProfileCard: isDisplayedOnProfileCard
            });
        default:
            return {
                description: null,
                icon: null,
                title: null,
                containerTypeText: null
            };
    }
};
module.exports["getContainerProperties"] = $c54f7acfc778f2e2$export$4fa7913af1c65224;

});

parcelRegister("hWTBk", function(module, exports) {
module.exports = new URL("ConfluenceIcon.3b027e05.svg", import.meta.url).toString();

});

parcelRegister("bjHDba", function(module, exports) {
module.exports = new URL("JiraIcon.a06d5f95.svg", import.meta.url).toString();

});

parcelRegister("dIk9b", function(module, exports) {
module.exports = new URL("LoomIcon.8c0f7a38.svg", import.meta.url).toString();

});

parcelRegister("cHq3C", function(module, exports) {
/**
 * FE debounce mechanism to avoid spamming invites when users consecutively
 * link and unlink teams from containers in quick succession. We'll log the
 * frequency of this occurring and decide whether to move debouncing to the
 * BE as a productionisation task.
 *
 * Uses module-level state rather than a globalThis singleton to avoid polluting
 * the global scope — a simple in-memory workaround is sufficient here.
 */ const $dd536ae456ac9c00$var$DEBOUNCE_MS = 15000;
const $dd536ae456ac9c00$var$pending = new Map();
// Callers pass IDs in different formats — the teams package passes full ARIs
// (e.g. "ari:cloud:identity::team/uuid") while teams-public passes bare IDs
// (e.g. "uuid"). Normalize to just the resource ID after the last "/" so both
// formats produce the same map key.
const $dd536ae456ac9c00$var$extractId = (ari)=>{
    const lastSlash = ari.lastIndexOf('/');
    return lastSlash === -1 ? ari : ari.substring(lastSlash + 1);
};
const $dd536ae456ac9c00$var$getKey = (teamId, containerId)=>`${$dd536ae456ac9c00$var$extractId(teamId)}:${$dd536ae456ac9c00$var$extractId(containerId)}`;
const $dd536ae456ac9c00$export$152c96fb070bb6 = {
    scheduleInvite: (teamId, containerId, callback)=>{
        const key = $dd536ae456ac9c00$var$getKey(teamId, containerId);
        const existing = $dd536ae456ac9c00$var$pending.get(key);
        if (existing) clearTimeout(existing.timeoutId);
        $dd536ae456ac9c00$var$pending.set(key, {
            callback: callback,
            timeoutId: setTimeout(()=>{
                $dd536ae456ac9c00$var$pending.delete(key);
                callback();
            }, $dd536ae456ac9c00$var$DEBOUNCE_MS)
        });
    },
    cancelInvite: (teamId, containerId)=>{
        const key = $dd536ae456ac9c00$var$getKey(teamId, containerId);
        const existing = $dd536ae456ac9c00$var$pending.get(key);
        if (existing) {
            clearTimeout(existing.timeoutId);
            $dd536ae456ac9c00$var$pending.delete(key);
        }
    },
    /**
	 * Immediately fires all pending callbacks and clears the queue.
	 * Called automatically on page unload (visibilitychange / beforeunload)
	 * so that debounced invites are not lost when the user navigates away.
	 *
	 * Important: callbacks invoked during page teardown must use
	 * `fetch({ keepalive: true })` or `navigator.sendBeacon` — a regular
	 * `fetch` without `keepalive` may be cancelled by the browser.
	 */ flushAll: ()=>{
        $dd536ae456ac9c00$var$pending.forEach((entry)=>{
            clearTimeout(entry.timeoutId);
            entry.callback();
        });
        $dd536ae456ac9c00$var$pending.clear();
    }
};
module.exports["spaceInviteScheduler"] = $dd536ae456ac9c00$export$152c96fb070bb6;

});

parcelRegister("cK1S8", function(module, exports) {
const $dfa26afbcfbb5a27$export$69caceff42c0da80 = [
    'confluence',
    'jira',
    'loom'
];


const $0e8298b04935fd86$var$PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-software',
    'jira-servicedesk',
    'jira-product-discovery',
    'loom'
];
const $0e8298b04935fd86$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        (0, $dfa26afbcfbb5a27$export$69caceff42c0da80).forEach((supportedProduct)=>{
            if (permission.resourceId.includes(supportedProduct)) acc[supportedProduct] = {
                ...acc[supportedProduct],
                [permission.permissionId]: acc[supportedProduct]?.[permission.permissionId] || permission.permitted
            };
        });
        return acc;
    }, {});
};
const $0e8298b04935fd86$export$e16fe80afd1ad74c = (cloudId, userId, permissionIds)=>{
    const body = permissionIds.reduce((acc, permissionId)=>{
        const permission = {
            permissionId: permissionId,
            resourceId: '',
            principalId: `ari:cloud:identity::user/${userId}`,
            dontRequirePrincipalInSite: true
        };
        $0e8298b04935fd86$var$PRODUCTS.forEach((product)=>{
            acc.push({
                ...permission,
                resourceId: `ari:cloud:${product}::site/${cloudId}`
            });
        });
        return acc;
    }, []);
    return JSON.stringify(body);
};
const $0e8298b04935fd86$export$a2eea90ce05a9f1c = (permissions, product, permissionIds)=>{
    if (!permissions[product]) return false;
    if ((!permissionIds || permissionIds.length === 0) && permissions[product]) return Object.values(permissions[product] || {}).some((value)=>value === true);
    return permissionIds?.some((permissionId)=>{
        const productPermissions = permissions[product];
        return productPermissions?.[permissionId];
    });
};
module.exports["transformPermissions"] = $0e8298b04935fd86$export$7fe0bfa353103198;
module.exports["getProductPermissionRequestBody"] = $0e8298b04935fd86$export$e16fe80afd1ad74c;
module.exports["hasProductPermission"] = $0e8298b04935fd86$export$a2eea90ce05a9f1c;

});

parcelRegister("3ZPUI", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $61fa4b3495654927$var$actions = {
    updateContainerLoading: (product, isLoading)=>({ setState: setState, getState: getState })=>{
            const containers = getState();
            const current = containers[product];
            if (current.isLoading === isLoading) return;
            setState({
                ...containers,
                [product]: {
                    ...current,
                    isLoading: isLoading
                }
            });
        },
    updateContainerCreated: (product, isCreated)=>({ setState: setState, getState: getState })=>{
            const containers = getState();
            const current = containers[product];
            if (current.isCreated === isCreated) return;
            setState({
                ...containers,
                [product]: {
                    ...current,
                    isCreated: isCreated
                }
            });
        }
};
const $61fa4b3495654927$var$initialState = {
    Jira: {
        isLoading: false,
        isCreated: false
    },
    Confluence: {
        isLoading: false,
        isCreated: false
    },
    Loom: {
        isLoading: false,
        isCreated: false
    }
};
const $61fa4b3495654927$var$store = (0, $1P1Tu.createStore)({
    initialState: $61fa4b3495654927$var$initialState,
    actions: $61fa4b3495654927$var$actions,
    name: 'CreateContainers'
});
/**
 * Custom hook for accessing and updating the state of container creation (Jira, Confluence, Loom).
 *
 * Provides state and actions for loading and creation status of each container type.
 *
 * @returns {object} State and actions for managing container creation.
 */ const $61fa4b3495654927$export$4775ec854211567 = (0, $9zUhf.createHook)($61fa4b3495654927$var$store);
module.exports["useCreateContainers"] = $61fa4b3495654927$export$4775ec854211567;

});

parcelRegister("g1rvx", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");


var $cK1S8 = parcelRequire("cK1S8");

const $3124300e7fe6b906$var$actions = {
    getPermissions: ({ userId: userId, cloudId: cloudId, enabled: enabled, permissionIds: permissionIds = [
        'manage',
        'write'
    ] })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading, permissions: permissions } = getState();
            if (isLoading || !userId || !cloudId || !enabled) return;
            const shouldFetch = !hasLoaded || permissionIds.some((permissionId)=>permissions.confluence?.[permissionId] === undefined || permissions.jira?.[permissionId] === undefined || permissions.loom?.[permissionId] === undefined);
            if (!shouldFetch) return;
            try {
                setState({
                    isLoading: true
                });
                const response = await fetch('/gateway/api/permissions/bulk/permitted', {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    method: 'POST',
                    credentials: 'include',
                    body: (0, $cK1S8.getProductPermissionRequestBody)(cloudId, userId, permissionIds)
                });
                if (!response.ok) throw new Error('Failed to fetch product permissions');
                const permissions = await response.json();
                dispatch($3124300e7fe6b906$var$actions.setPermissions(permissions));
            } catch (error) {
                dispatch($3124300e7fe6b906$var$actions.setError(new Error('Failed to fetch product permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $cK1S8.transformPermissions)(permissions),
                permissionsResponse: permissions
            });
        }
};
const $3124300e7fe6b906$var$Store = (0, $1P1Tu.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {}
    },
    actions: $3124300e7fe6b906$var$actions,
    name: 'product-permissions-old'
});
const $3124300e7fe6b906$export$933ed92af1ed5de9 = (0, $9zUhf.createHook)($3124300e7fe6b906$var$Store);


const $c62cb3f798a3455e$export$5814f9544ee53f3b = ({ userId: userId, cloudId: cloudId, permissionIds: permissionIds }, { enabled: enabled } = {
    enabled: true
})=>{
    const [state, { getPermissions: getPermissions }] = (0, $3124300e7fe6b906$export$933ed92af1ed5de9)();
    const fetchData = (0, $42omo.useCallback)(async ()=>{
        getPermissions({
            cloudId: cloudId,
            userId: userId,
            enabled: enabled,
            permissionIds: permissionIds || [
                'manage',
                'write'
            ]
        });
    }, [
        cloudId,
        enabled,
        getPermissions,
        userId,
        permissionIds
    ]);
    (0, $42omo.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissions,
        error: state.error
    };
};
module.exports["useProductPermissions"] = $c62cb3f798a3455e$export$5814f9544ee53f3b;

});

parcelRegister("aYWXT", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $521399c659dfa8b9$export$7cd9d491ff28b738 = (container)=>{
    return {
        contentTitle: container.name,
        description: '',
        linkUri: container.link || ''
    };
};
const $521399c659dfa8b9$export$34d06abc801403e2 = (link, iconData)=>{
    return {
        id: link.linkId,
        type: 'WebLink',
        name: link.contentTitle,
        icon: iconData?.iconUrl || null,
        link: link.linkUri
    };
};
const $521399c659dfa8b9$export$6a7bb6c7b84e9956 = (links, linkIcons = [])=>{
    return links.map((link)=>{
        const iconData = linkIcons.find((icon)=>icon.linkUrl === link.linkUri);
        return $521399c659dfa8b9$export$34d06abc801403e2(link, iconData);
    });
};
const $521399c659dfa8b9$export$26e8ccc2e609ae74 = (input)=>{
    return 'contentTitle' in input && 'linkUri' in input && !('type' in input) && !('id' in input);
};



var $hogmh = parcelRequire("hogmh");


var $jUUM4 = parcelRequire("jUUM4");

const $18f36a201d3ef90d$var$MAX_LINKS_LIMIT = 10;
const $18f36a201d3ef90d$export$5200d5ff4aebd4a7 = (teamId, enableContainers = true)=>{
    const { teamContainers: teamContainers, loading: containersLoading, hasLoaded: containersHasLoaded, error: containersError, addTeamContainer: addTeamContainer, unlinkTeamContainers: unlinkTeamContainers } = (0, $hogmh.useTeamContainers)(teamId, enableContainers);
    const [{ links: links, linkIcons: linkIcons, isLoading: webLinksLoading, hasError: webLinksError, hasLoaded: webLinksHasLoaded, iconsLoading: iconsLoading, iconHasLoaded: iconHasLoaded }, { getTeamWebLinks: getTeamWebLinks, createTeamWebLink: createTeamWebLink, updateTeamWebLink: updateTeamWebLink, removeWebLink: removeWebLink }] = (0, $jUUM4.useTeamWebLinks)(teamId);
    (0, $42omo.useEffect)(()=>{
        getTeamWebLinks(teamId);
    }, [
        getTeamWebLinks,
        teamId
    ]);
    const webLinkContainers = (0, $42omo.useMemo)(()=>(0, $521399c659dfa8b9$export$6a7bb6c7b84e9956)(links, linkIcons), [
        links,
        linkIcons
    ]);
    const allContainers = (0, $42omo.useMemo)(()=>[
            ...teamContainers,
            ...webLinkContainers
        ], [
        teamContainers,
        webLinkContainers
    ]);
    const canAddMoreLink = (0, $42omo.useMemo)(()=>allContainers.length < $18f36a201d3ef90d$var$MAX_LINKS_LIMIT, [
        allContainers.length
    ]);
    const addTeamLink = (0, $42omo.useCallback)(async (containerOrWebLink)=>{
        if ((0, $521399c659dfa8b9$export$26e8ccc2e609ae74)(containerOrWebLink)) return await createTeamWebLink(teamId, containerOrWebLink);
        else if (containerOrWebLink.type === 'WebLink') {
            const webLink = (0, $521399c659dfa8b9$export$7cd9d491ff28b738)(containerOrWebLink);
            return await createTeamWebLink(teamId, webLink);
        } else {
            addTeamContainer(containerOrWebLink);
            return Promise.resolve(containerOrWebLink);
        }
    }, [
        teamId,
        createTeamWebLink,
        addTeamContainer
    ]);
    const updateTeamLinkById = (0, $42omo.useCallback)(async (linkId, updatedFields)=>{
        const container = allContainers.find((link)=>link.id === linkId);
        if (!container) return;
        if (container.type === 'WebLink') {
            const currentWebLink = (0, $521399c659dfa8b9$export$7cd9d491ff28b738)(container);
            const updatedWebLink = {
                ...currentWebLink,
                ...updatedFields
            };
            return await updateTeamWebLink(teamId, linkId, updatedWebLink);
        }
    }, [
        teamId,
        allContainers,
        updateTeamWebLink
    ]);
    const removeTeamLink = (0, $42omo.useCallback)(async (container)=>{
        if (container.type === 'WebLink') await removeWebLink(teamId, container.id);
        else await unlinkTeamContainers(container.id);
    }, [
        teamId,
        removeWebLink,
        unlinkTeamContainers
    ]);
    return {
        isLoading: containersLoading || webLinksLoading,
        hasError: !!containersError || webLinksError,
        containersError: !!containersError,
        webLinksError: webLinksError,
        containersHasLoaded: containersHasLoaded,
        webLinksHasLoaded: webLinksHasLoaded,
        hasLoaded: containersHasLoaded && webLinksHasLoaded,
        teamLinks: allContainers,
        canAddMoreLink: canAddMoreLink,
        iconsLoading: iconsLoading,
        iconHasLoaded: iconHasLoaded,
        addTeamLink: addTeamLink,
        updateTeamLinkById: updateTeamLinkById,
        removeTeamLink: removeTeamLink
    };
};
module.exports["useTeamLinksAndContainers"] = $18f36a201d3ef90d$export$5200d5ff4aebd4a7;

});

parcelRegister("2Pqp7", function(module, exports) {

let $20f4d37bdcd02a5f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $20f4d37bdcd02a5f$var$load("hhss7"),
    $20f4d37bdcd02a5f$var$load("hfT7k")
]).then(()=>parcelRequire('lvs8O'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("bnTdW", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $esRft = parcelRequire("esRft");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $1bY7o = parcelRequire("1bY7o");


var $gdv5Z = parcelRequire("gdv5Z");


var $5KpJQ = parcelRequire("5KpJQ");

const $cdbd58dfaa7da816$var$styles = {
    linkIconWrapperSmall: "_19pkv77o _2hwxv77o _otyrv77o _18u0v77o"
};
const $cdbd58dfaa7da816$export$6d6da6edaddd5876 = ({ containerType: containerType, title: title, containerIcon: containerIcon, size: size = 'medium' })=>{
    const isMedium = size === 'medium';
    if (containerType === 'LoomSpace') return /*#__PURE__*/ (0, $l998X.jsx)((0, $5KpJQ.LoomSpaceAvatar), {
        spaceName: title,
        size: isMedium ? 'large' : size,
        testId: `linked-container-${containerType}-icon`
    });
    // This is a fallback icon for WebLink if the containerIcon is not present
    if (containerType === 'WebLink' && !containerIcon) return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)(!isMedium && $cdbd58dfaa7da816$var$styles.linkIconWrapperSmall),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
            label: "",
            spacing: isMedium ? 'default' : 'compact',
            appearance: "default",
            "aria-hidden": "true",
            tabIndex: -1,
            testId: "linked-container-WebLink-new-icon",
            icon: ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
                    label: "",
                    size: isMedium ? 'medium' : 'small'
                })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $esRft.default), {
        appearance: "square",
        borderColor: "transparent",
        size: size,
        src: containerIcon,
        testId: `linked-container-${containerType}-icon`
    });
};
module.exports["ContainerIcon"] = $cdbd58dfaa7da816$export$6d6da6edaddd5876;

});

parcelRegister("5KpJQ", function(module, exports) {
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $26c57f7c46c41cfd$exports = {};
"use strict";
function $26c57f7c46c41cfd$var$hash(str) {
    var hash = 5381, i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return hash >>> 0;
}
$26c57f7c46c41cfd$exports = $26c57f7c46c41cfd$var$hash;


var $e0c49377f9432a00$var$SpaceColors = /*#__PURE__*/ function(SpaceColors) {
    SpaceColors["ORANGE_LIGHT"] = "#FFD5D2";
    SpaceColors["BLUE_LIGHT"] = "#CFE1FD";
    SpaceColors["YELLOW_LIGHT"] = "#FCE4A6";
    SpaceColors["TEAL"] = "#BAF3DB";
    return SpaceColors;
}($e0c49377f9432a00$var$SpaceColors || {});
var $e0c49377f9432a00$var$AvatarTextColors = /*#__PURE__*/ function(AvatarTextColors) {
    AvatarTextColors["ORANGE_DARK"] = "#AE2E24";
    AvatarTextColors["BLUE_DARK"] = "#123263";
    AvatarTextColors["YELLOW_DARK"] = "#9E4C00";
    AvatarTextColors["TEAL_DARK"] = "#164B35";
    return AvatarTextColors;
}($e0c49377f9432a00$var$AvatarTextColors || {});
const $e0c49377f9432a00$var$AVATAR_CONTAINER_COLORS = [
    "#FFD5D2",
    "#CFE1FD",
    "#FCE4A6",
    "#BAF3DB"
];
const $e0c49377f9432a00$var$AVATAR_TEXT_COLORS = [
    "#AE2E24",
    "#123263",
    "#9E4C00",
    "#164B35"
];
const $e0c49377f9432a00$var$hash = (str)=>{
    let hash = $26c57f7c46c41cfd$exports(str);
    hash = ~hash;
    return Math.abs(Number(hash));
};
const $e0c49377f9432a00$export$a3b2d23d4cacf752 = (spaceName)=>{
    return spaceName?.trim().length ? spaceName.trim()[0].toUpperCase() : '';
};
const $e0c49377f9432a00$export$55185ae96e679e0a = (spaceName)=>{
    const avatarHash = $e0c49377f9432a00$var$hash(spaceName);
    return $e0c49377f9432a00$var$AVATAR_CONTAINER_COLORS[avatarHash % $e0c49377f9432a00$var$AVATAR_CONTAINER_COLORS.length];
};
const $e0c49377f9432a00$export$7063fff24f5d2ae7 = (spaceName)=>{
    const avatarHash = $e0c49377f9432a00$var$hash(spaceName);
    return $e0c49377f9432a00$var$AVATAR_TEXT_COLORS[avatarHash % $e0c49377f9432a00$var$AVATAR_TEXT_COLORS.length];
};


const $a45374652d92ddd7$var$boxStyle = null;
const $a45374652d92ddd7$var$smallBoxStyle = null;
const $a45374652d92ddd7$var$largeBoxStyle = null;
function $a45374652d92ddd7$export$6055fe3c3d07f8d9({ spaceName: spaceName = '', size: size = 'small', testId: testId = '' }) {
    const avatarText = (0, $e0c49377f9432a00$export$a3b2d23d4cacf752)(spaceName);
    const containerColor = (0, $e0c49377f9432a00$export$55185ae96e679e0a)(spaceName);
    const textColor = (0, $e0c49377f9432a00$export$7063fff24f5d2ae7)(spaceName);
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            backgroundColor: containerColor,
            color: textColor
        },
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _4cvr1h6o _1bah1h6o",
            size === 'small' ? "_11c81qyo _4t3iqslr _1ul9qslr _19pkv77o _2hwxv77o _otyrv77o _18u0v77o" : "_11c81af2 _18zrv77o _4t3izwfg _1bsbzwfg"
        ]),
        children: avatarText
    });
}
module.exports["LoomSpaceAvatar"] = $a45374652d92ddd7$export$6055fe3c3d07f8d9;

});

parcelRegister("jOrEm", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $u9agA = parcelRequire("u9agA");

var $iXCQx = parcelRequire("iXCQx");

const $b1a6c04f3d83017d$var$styles = {
    separator: "_t9ec18p1"
};
const $b1a6c04f3d83017d$var$SEPARATOR = "\u2022";
const $b1a6c04f3d83017d$export$1ff3c3f08ae963c0 = ()=>/*#__PURE__*/ (0, $l998X.jsx)((0, $u9agA.default), {
        xcss: $b1a6c04f3d83017d$var$styles.separator,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
            size: "small",
            color: "color.text.subtle",
            children: $b1a6c04f3d83017d$var$SEPARATOR
        })
    });
module.exports["Separator"] = $b1a6c04f3d83017d$export$1ff3c3f08ae963c0;

});

parcelRegister("2OhPQ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $h82at = parcelRequire("h82at");

var $1cfRh = parcelRequire("1cfRh");


var $1qfLF = parcelRequire("1qfLF");


var $1Whri = parcelRequire("1Whri");


var $52EPl = parcelRequire("52EPl");

var $dAYOx = parcelRequire("dAYOx");

var $ahaN7 = parcelRequire("ahaN7");


var $hmuev = parcelRequire("hmuev");


var $9VJDA = parcelRequire("9VJDA");


var $gdv5Z = parcelRequire("gdv5Z");


var $fDXXi = parcelRequire("fDXXi");


var $3gadb = parcelRequire("3gadb");

const $f4b036555297915a$var$styles = {
    crossIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug",
    showMoreIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug",
    iconHidden: "_1e0cglyw",
    iconVisible: "_1e0c1txw"
};
const $f4b036555297915a$var$messages = (0, $h82at.defineMessages)({
    disconnectTooltip: {
        id: "ptc-directory.team-containers.disconnect-button.tooltip",
        defaultMessage: "Disconnect"
    },
    editLink: {
        id: "ptc-directory.team-containers.edit-link",
        defaultMessage: "Edit link"
    },
    removeLink: {
        id: "ptc-directory.team-containers.remove-link",
        defaultMessage: "Remove"
    }
});
const $f4b036555297915a$export$7f8ec3a4a0c86d35 = ({ containerType: containerType, title: title, containerId: containerId, hovered: hovered, focused: focused, isDropdownOpen: isDropdownOpen, showKeyboardFocus: showKeyboardFocus, onDisconnectButtonClick: onDisconnectButtonClick, onEditLinkClick: onEditLinkClick, onDropdownOpenChange: onDropdownOpenChange })=>{
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const { fireEvent: fireEvent } = (0, $fDXXi.useAnalyticsEvents)(); // Show icons when:
    // 1. Hovering over the card
    // 2. Dropdown is open
    // 3. Focused via keyboard navigation (when showKeyboardFocus is true)
    const shouldShowIcon = hovered || isDropdownOpen || focused && showKeyboardFocus;
    const handleDisconnectClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        onDisconnectButtonClick();
        fireEvent('ui.button.clicked.containerUnlinkButton', {
            containerSelected: {
                container: containerType,
                containerId: containerId
            }
        });
    };
    const handleEditLinkClick = (e)=>{
        e.preventDefault();
        e.stopPropagation();
        onEditLinkClick?.();
        fireEvent('ui.button.clicked.containerEditLinkButton', {
            containerSelected: {
                container: containerType,
                containerId: containerId
            }
        });
    };
    if (containerType === 'WebLink') return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($f4b036555297915a$var$styles.showMoreIconWrapper, shouldShowIcon ? $f4b036555297915a$var$styles.iconVisible : $f4b036555297915a$var$styles.iconHidden),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $52EPl.default), {
            trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                    ref: triggerRef,
                    ...triggerProps,
                    label: `more options for ${title}`,
                    appearance: "subtle",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                            ...iconProps,
                            size: "small"
                        }),
                    spacing: "compact"
                }),
            placement: "bottom-end",
            shouldRenderToParent: true,
            onOpenChange: (attrs)=>{
                onDropdownOpenChange(attrs.isOpen);
            },
            children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $ahaN7.default), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: handleEditLinkClick,
                        children: formatMessage($f4b036555297915a$var$messages.editLink)
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $dAYOx.default), {
                        onClick: handleDisconnectClick,
                        children: formatMessage($f4b036555297915a$var$messages.removeLink)
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
        xcss: (0, $1Whri.cx)($f4b036555297915a$var$styles.crossIconWrapper, shouldShowIcon ? $f4b036555297915a$var$styles.iconVisible : $f4b036555297915a$var$styles.iconHidden),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
            content: formatMessage($f4b036555297915a$var$messages.disconnectTooltip),
            position: "top",
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
                label: `disconnect the container ${title}`,
                appearance: "subtle",
                icon: (iconProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hmuev))), {
                        ...iconProps,
                        size: "small"
                    }),
                spacing: "compact",
                onClick: handleDisconnectClick
            })
        })
    });
};
module.exports["TeamLinkCardActions"] = $f4b036555297915a$export$7f8ec3a4a0c86d35;

});

parcelRegister("kMNTc", function(module, exports) {
/**
 * Extract the domain from the URL. Strips "www" subdomains
 * e.g. http://dogs.animals.com/yellow/golden-retriever becomes "dogs.animals.com"
 * e.g. http://www.blake.com/memes becomes "blake.com"
 *
 * Return an empty string if a totally invalid url is somehow passed in.
 * @param url
 */ const $1c729a8c68a0370e$export$cda14c9dfe45538 = (url)=>{
    let hostname;
    try {
        try {
            hostname = $1c729a8c68a0370e$export$eb5a321f13bbb969(url);
        } catch (noProtocolError) {
            /**
			 * Backend (Legion) validates whether the string is URI compliant. But URL expects
			 * the string to have a protocol. This is not validated by URI compliancy. So
			 * following is just a quick fix just for display purposes.
			 */ hostname = $1c729a8c68a0370e$export$eb5a321f13bbb969('http://' + url);
        }
    } catch (error) {
        return '';
    }
    return hostname.replace(/^www\./, '');
};
const $1c729a8c68a0370e$export$eb5a321f13bbb969 = (url)=>{
    const urlObj = new URL(url);
    return urlObj.hostname;
};
module.exports["getDomainFromLinkUri"] = $1c729a8c68a0370e$export$cda14c9dfe45538;

});

parcelRegister("jcyBI", function(module, exports) {
function $7a2fbd03d879f5df$export$f8b10795b163b139(cloudId) {
    if (!cloudId) return undefined;
    return {
        metadata: {
            headers: {
                'X-Query-Context': `ari:cloud:platform::site/${cloudId}`
            }
        }
    };
}
function $7a2fbd03d879f5df$export$1bb4ca53dbed1b2b(cloudId) {
    if (!cloudId) return undefined;
    return {
        'X-Query-Context': `ari:cloud:platform::site/${cloudId}`
    };
}
module.exports["createQueryContextCacheConfig"] = $7a2fbd03d879f5df$export$f8b10795b163b139;

});


//# sourceMappingURL=TeamProfileCardEntryPoint.d47935d8.js.map
